import { chain, capitalize } from 'lodash';
import { ToastProgrammatic as Toast } from 'buefy';

export const assignHelper = (attribute) => (state, value) => {
  state[attribute] = value;
};

export const imageNameForProduct = (product, defaultValue = 'TiroirOptiqueVert') => {
  const svgName = product.unibaies_svg || product.svg || defaultValue;
  return chain(
    svgName.split('.')[0],
  ).words().map(capitalize).join('')
    .value();
};

export const isRackable = (product) => product.productable_type !== 'Baie'
  && product.productable_type !== 'Coffret'
  && product.taille > 0;

export const isContainer = (product) => product.productable_type === 'Baie'
  || product.productable_type === 'Coffret';


export function openToast(
  message, type = 'is-success', position = 'is-bottom', duration = 7500,
) {
  Toast.open({
    message, type, position, duration,
  });
}

export function isTiroirRelevant(tiroir, extremite, mode, nombreDeBrins) {
  return tiroir.traversee === extremite
         && tiroir.categorie.includes(mode)
         && tiroir.nombre_de_fibres >= nombreDeBrins;
}
